import React from 'react';

import { Page } from '../page/page';
import { PageSection } from '../pageSection/pageSection';
import { RoundButton } from '../roundButton/roundButton';
import { Heading } from '../heading/heading';
import { MdOutlineSearch as SearchIcon } from 'react-icons/md';
import { MdAdd as AddIcon } from 'react-icons/md';
import { MdArrowBack as BackIcon } from 'react-icons/md';
import { GenericInput } from '../genericInput/genericInput';
import styles from './pageListSection.module.scss';

const PageListSection = ({
  onAdd,
  onSearch,
  searchQuery,
  title,
  children,
  icon,
  className,
  searchPlaceholder,
  showBackButton,
  onBackClick,
}) => (
  <Page>
    <PageSection
      title={
        showBackButton ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', whiteSpace: 'nowrap' }}>
            <RoundButton 
              onClick={onBackClick} 
              size="small" 
              theme="secondary"
              className={styles.backButton}
            >
              <BackIcon size={20} />
            </RoundButton>
            <Heading size="large">{title}</Heading>
          </div>
        ) : title
      }
      icon={icon}
      search={
        onSearch && (
          <GenericInput
            name="keyword"
            type="text"
            placeholder={searchPlaceholder}
            icon={<SearchIcon />}
            iconRight
            value={searchQuery}
            onChange={(event) => onSearch(event.target.value)}
          />
        )
      }
      className={className}
      action={
        onAdd && (
          <RoundButton onClick={onAdd}>
            <AddIcon size={30} />
          </RoundButton>
        )
      }
    >
      {children}
    </PageSection>
  </Page>
);

export default PageListSection;
